/**
 * Opens a modal by adding the 'show' class to the selected element and optionally executes a callback.
 *
 * @param selector - A CSS selector string to target the modal element in the DOM.
 * @param callback - An optional callback function to execute after the modal is shown.
 * @returns `true` if the modal was successfully shown, the result of the callback if provided, or `false` if no modal was found.
 */
export function openModal<T = void>(selector: string | HTMLElement, callback?: () => T): boolean | T {
    const modal = selector instanceof HTMLElement ? selector : document.querySelector(selector);

    if (modal instanceof HTMLElement) {
        modal.classList.add('show');
        modal.style.display = "block";
        (window as any).modalID = modal.id;
        if (callback) {
            return callback();
        }
        return true;
    } else {
        console.error(`No modal found with selector: ${selector}`, modal);
        return false;
    }
}